module.exports = __webpack_public_path__ + "static/media/history_18.67a0c7bc.jpg";